import { render } from "./toastrPage.vue?vue&type=template&id=35065b1a"
import script from "./toastrPage.vue?vue&type=script&lang=js"
export * from "./toastrPage.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__